import WonderKind from '@/roc/wonders/base/WonderKind';
import { useWonderStore } from "@/roc/stores/WonderStore";
class SynergyEffect {
    __effect;
    __synergy;
    constructor(effect, synergy) {
        this.__effect = effect;
        this.__synergy = synergy;
    }
    get effect() {
        return this.__effect;
    }
    formatDescription(level) {
        const desc = this.__effect.formatDescription(level);
        let kindName;
        switch (this.__synergy.kind) {
            case WonderKind.STATUE:
                kindName = 'statue';
                break;
            case WonderKind.TEMPLE:
                kindName = 'temple';
                break;
            case WonderKind.FORTRESS:
                kindName = 'fortress';
                break;
            case WonderKind.PALACE:
                kindName = 'palace';
                break;
            case WonderKind.NAVAL:
                kindName = 'naval';
                break;
            case WonderKind.NATURE:
                kindName = 'nature';
                break;
            case WonderKind.ARENA:
                kindName = 'arena';
                break;
        }
        return desc + ' for every additional active ' + kindName;
    }
    getMultiplier() {
        const wonderStore = useWonderStore();
        let multiplier = 0;
        wonderStore.mapWonders((src, config) => {
            if (src.id !== this.__synergy.wonderId && config.active && (src.kind & this.__synergy.kind) !== 0) {
                multiplier++;
            }
            return true;
        });
        return multiplier;
    }
}
export default SynergyEffect;
